import type { NewsItem } from "@/types";

const nc1 =
  "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20shot%20of%20a%20film%20crew%20with%20cameras%20in%20a%20dark%20misty%20green%20jungle%20surrounded%20by%20foliage%20and%20tripods%20with%20warm%20amber%20light%20atmospheric%20documentary%20style%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-1&orientation=landscape";
const nc2 =
  "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20a%20film%20premiere%20red%20carpet%20entrance%20at%20night%20with%20warm%20amber%20spotlights%20and%20dark%20green%20decor%20elegant%20atmospheric%20event%20photography%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-2&orientation=landscape";
const nc3 =
  "https://readdy.ai/api/search-image?query=Cinematic%20documentary%20shot%20of%20a%20traditional%20bamboo%20musical%20instrument%20and%20recording%20equipment%20inside%20a%20dark%20green%20jungle%20studio%20with%20soft%20warm%20amber%20light%20atmospheric%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-3&orientation=landscape";
const nc4 =
  "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20heavy%20monsoon%20rain%20falling%20over%20a%20dark%20green%20jungle%20river%20with%20thick%20mist%20and%20moody%20atmospheric%20light%20documentary%20style%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-4&orientation=landscape";
const nc5 =
  "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20an%20audience%20watching%20a%20film%20in%20a%20dark%20cinema%20with%20warm%20amber%20screen%20glow%20on%20their%20faces%20atmospheric%20moody%20event%20photography%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-5&orientation=landscape";
const nc6 =
  "https://readdy.ai/api/search-image?query=Cinematic%20shot%20of%20an%20ancient%20map%20and%20notebook%20resting%20on%20a%20wooden%20table%20beside%20pressed%20green%20leaves%20under%20soft%20warm%20amber%20light%20atmospheric%20still%20life%20professional%20color%20grading%20subtle%20film%20grain%20no%20text%20no%20watermark&width=1200&height=675&seq=jungle-news-6&orientation=landscape";

export const news: NewsItem[] = [
  {
    id: "n1",
    title: "《激情丛林》宣布密钥延期，全国放映延长至年底",
    date: "2024-11-16",
    category: "官方公告",
    excerpt:
      "片方正式宣布，影片全国放映周期将延长至 12 月 31 日，并同步追加部分艺术影厅的排片，以满足持续增长的观影需求。",
    cover: nc1,
    content: [
      "片方今日正式发布公告，《激情丛林》的全国放映周期将延长至 12 月 31 日。自上映以来，影片凭借扎实的口碑实现了长线放映，多个城市的核心影厅保持较高的上座率。",
      "为了让更多观众有机会在大银幕上观看，片方还追加了部分艺术影厅与杜比影厅的排片。主创团队表示，希望通过更长的放映周期，让这部需要耐心的作品被更多人看见。",
      "同时，片方提醒观众通过正规渠道购票，并关注所在城市影院的实际排片信息。",
    ],
  },
  {
    id: "n2",
    title: "剧组在真实雨季拍摄：一天只完成两个镜头的幕后",
    date: "2024-11-14",
    category: "幕后花絮",
    excerpt:
      "剧组在东南亚雨林驻扎超过四个月，为了等待一束合适的光，常常一天只能完成两个镜头。这份近乎偏执的坚持，成就了银幕上的真实感。",
    cover: nc4,
    content: [
      "在最新曝光的幕后花絮中，导演陆云舟透露，全片绝大部分镜头都在真实雨林中完成，且刻意选择在雨季拍摄。“我们需要那种潮湿、黏腻、随时会失控的质感，那是棚里做不出来的。”",
      "由于坚持自然光拍摄，剧组常常要在泥泞中等待数小时。摄影指导罗青野回忆，有时一天下来只能完成两个镜头，但没有人抱怨，因为大家都相信“等待本身就是表演的一部分”。",
      "花絮中还能看到，为了不破坏环境，剧组在每一处拍摄点都会进行细致的恢复工作。制片人田知远表示：“我们拍的是关于敬畏自然的故事，那我们也必须真的敬畏它。”",
    ],
  },
  {
    id: "n3",
    title: "全国路演收官，主创分享最后的杀青夜",
    date: "2024-11-12",
    category: "活动报道",
    excerpt:
      "历时一个月的全国路演正式收官。在最后一站，主创团队与观众分享了拍摄期间最难忘的杀青之夜，现场数次响起掌声。",
    cover: nc2,
    content: [
      "《激情丛林》全国路演活动在上周末正式收官。一个月的时间里，主创团队走过十余座城市，与数万名观众面对面交流。",
      "在最后一站的映后交流中，演员陈默回忆起杀青之夜：那一晚雨下得特别大，全组人在泥地里站了很久，没人愿意先离开。“好像只要不走，那个故事就还没有结束。”",
      "江晚则分享了塑造苏雨桐的心路历程。她说，这个角色教会她的最重要的一件事，是“承认自己的执念，然后学会和它相处”。",
      "现场观众反响热烈，多场交流延长近半小时。有观众表示，看完电影再听主创讲述，对影片的理解又深了一层。",
    ],
  },
  {
    id: "n4",
    title: "导演陆云舟谈选角：为什么是陈默",
    date: "2024-11-09",
    category: "幕后花絮",
    excerpt:
      "在一片猜测声中，导演首次完整讲述了选择陈默出演林深的原因。他要的不是表演，而是一种“存在感”。",
    cover: nc1,
    content: [
      "在近日的一次深度访谈中，导演陆云舟首次完整回应了关于林深选角的讨论。他坦言，这个角色是全片最难选的一个。",
      "“林深几乎不解释自己，所以演员必须有能力用沉默撑住一整个镜头。”陆云舟说，“我第一次见到陈默，是他坐在角落里看剧本，两个小时没说话。那一刻我就知道，是他了。”",
      "陈默本人则表示，理解林深的过程比想象中更难。“他不是不会表达，他只是觉得表达没有用。我要做的，是让观众相信这种‘没有用’。”",
      "访谈视频上线后迅速引发讨论，不少观众表示，看完之后对林深这个角色有了全新的理解。",
    ],
  },
  {
    id: "n5",
    title: "影片发布全新人物海报与终极预告",
    date: "2024-11-06",
    category: "官方公告",
    excerpt:
      "五张人物海报与一支终极预告同步释出，逐一揭开五位主要角色的立场与秘密，为影片的长线放映再添一把火。",
    cover: nc6,
    content: [
      "片方今日发布五张全新人物海报，分别聚焦林深、苏雨桐、阿岩、赵景行与何清。每张海报都配有一句角色独白，暗示其在故事中的立场与秘密。",
      "与海报同步释出的还有一支终极预告。预告节奏克制，却信息密集，将“带走什么、留下什么”的核心母题推到台前。",
      "片方表示，此次物料发布主要是为了配合密钥延期，让更多尚未观影的观众了解影片。所有海报与预告均已通过官方渠道公开。",
    ],
  },
  {
    id: "n6",
    title: "《激情丛林》亮相国际影展主竞赛单元",
    date: "2024-11-03",
    category: "活动报道",
    excerpt:
      "影片受邀参加国际影展主竞赛单元展映，映后获得持续数分钟的掌声，多家海外媒体给予积极评价。",
    cover: nc2,
    content: [
      "《激情丛林》近日受邀参加某国际影展主竞赛单元的展映活动。放映结束后，现场响起持续数分钟的掌声。",
      "导演陆云舟与主演江晚出席映后交流。当被问及为何选择如此克制的叙事方式时，陆云舟回答：“因为真正的恐惧和敬畏，从来都不是喊出来的。”",
      "多家海外媒体在报道中肯定了影片的视听语言，称其“在类型框架中完成了一次沉静的突破”。",
      "据悉，影片还将在影展期间举办两场特别放映。",
    ],
  },
  {
    id: "n7",
    title: "摄影指导罗青野揭秘“零补光”拍摄法",
    date: "2024-10-31",
    category: "幕后花絮",
    excerpt:
      "在最新的技术分享中，摄影指导罗青野首次系统讲解了影片“零补光”的拍摄理念，以及它对整个剧组提出的严苛要求。",
    cover: nc4,
    content: [
      "摄影指导罗青野在一场面向业内的技术分享会上，详细拆解了《激情丛林》“零补光”的拍摄方法。",
      "所谓“零补光”，并非简单地不开灯，而是把自然光的每一处变化都纳入叙事计划。罗青野会提前数月勘景，记录同一地点在不同时段的光线数据，再据此决定拍摄顺序。",
      "这套方法对演员和剧组提出了极高要求：任何一场戏都可能因为一片云而被迫等待。但罗青野认为，正是这种不可控，构成了影片独特的气质。",
      "分享会现场座无虚席，不少从业者表示收获颇丰。",
    ],
  },
  {
    id: "n8",
    title: "影片上线幕后纪录片《进入丛林》",
    date: "2024-10-28",
    category: "官方公告",
    excerpt:
      "一部时长 50 分钟的幕后纪录片《进入丛林》正式上线，完整记录了影片从勘景到杀青的整个过程。",
    cover: nc1,
    content: [
      "片方宣布，幕后纪录片《进入丛林》正式上线。影片时长约 50 分钟，完整记录了《激情丛林》从前期勘景、选角到实景拍摄、杀青的整个过程。",
      "纪录片中收录了大量未公开的现场画面，包括剧组在暴雨中抢救设备的惊险时刻，以及演员们收工后在营地交流的珍贵片段。",
      "导演陆云舟在片中表示，这部纪录片并不是为了“炫技”，而是希望观众看到，一部关于自然的电影，背后需要付出怎样的代价。",
      "该纪录片面向所有观众免费开放。",
    ],
  },
  {
    id: "n9",
    title: "影迷专场放映会现场实录",
    date: "2024-10-25",
    category: "活动报道",
    excerpt:
      "一场由影迷自发组织的专场放映会在上周末举行，散场后观众久久不愿离去，自发围坐讨论影片主题。",
    cover: nc5,
    content: [
      "上周末，一场由影迷社群自发组织的《激情丛林》专场放映会在某艺术影院举行。近百名观众参与了本次活动。",
      "放映结束后，观众并未立即离场，而是自发围坐在影厅外讨论影片。话题从剧情细节延伸到人与自然的关系，讨论持续了近两个小时。",
      "活动组织者表示，举办这场放映的初衷，是希望为喜欢这部影片的人提供一个交流的空间。“好电影值得被讨论。”",
      "据悉，类似规模的影迷专场还将在更多城市陆续举办。",
    ],
  },
  {
    id: "n10",
    title: "配乐顾长风：用竹制乐器录出丛林的呼吸",
    date: "2024-10-22",
    category: "幕后花絮",
    excerpt:
      "原创配乐顾长风分享了影片音乐创作的幕后故事。为还原真实的丛林质感，他大量使用竹制乐器与环境采样。",
    cover: nc3,
    content: [
      "《激情丛林》的原创配乐顾长风在采访中透露，整部影片的音乐创作几乎完全建立在真实采样之上。",
      "“我先在雨林里待了三周，什么也没写，只是听。”顾长风说。他录制了数百小时的环境音，再用竹笛、竹鼓等传统乐器进行呼应，让配乐与自然声之间没有清晰边界。",
      "这种创作方式也带来了困难：如何让音乐在需要时“浮现”，又在该消失时彻底退场。顾长风笑称，这可能是他做过“留白最多”的一张原声。",
      "原声专辑现已完整上线。",
    ],
  },
  {
    id: "n11",
    title: "《激情丛林》票房与口碑双丰收，创文艺冒险片新纪录",
    date: "2024-10-19",
    category: "官方公告",
    excerpt:
      "上映首周，影片在票房与口碑两个维度均表现亮眼，成为近年表现最好的文艺向冒险电影之一。",
    cover: nc5,
    content: [
      "据片方公布的数据，《激情丛林》上映首周表现亮眼，在多个评分平台维持高位，成为近年口碑表现最好的文艺向冒险电影之一。",
      "影片以克制的叙事和强烈的视听风格，吸引了大量非类型片受众走进影院。片方表示，观众的耐心与讨论热情超出了预期。",
      "“我们原本做好了‘小众’的准备，”制片人田知远说，“但事实证明，观众比我们想象的更愿意接受不讨好的作品。”",
      "片方同时感谢了所有参与观影与讨论的观众。",
    ],
  },
  {
    id: "n12",
    title: "主创出席公益放映，关注雨林保护",
    date: "2024-10-17",
    category: "活动报道",
    excerpt:
      "主创团队出席一场以雨林保护为主题的公益放映活动，并宣布将部分周边收益用于支持相关环保项目。",
    cover: nc2,
    content: [
      "《激情丛林》主创团队近日出席了一场以雨林保护为主题的公益放映活动。导演陆云舟与主演江晚、岩川到场参与交流。",
      "活动现场播放了影片精选片段，并邀请了环保领域的研究者分享雨林保护的现状。主创团队表示，拍摄经历让他们对这片土地有了更深的牵挂。",
      "片方同时宣布，将把部分官方周边收益用于支持相关环保项目。“我们拍了一个关于索取的故事，所以更想做一些关于给予的事。”",
      "活动吸引了众多观众参与，现场气氛温暖而庄重。",
    ],
  },
];

export const newsCategories = ["全部", "幕后花絮", "活动报道", "官方公告"];